import BRSR from '../../../../src/assets/BRSR.png';
import CBAM from '../../../../src/assets/cbam.png';
import CDP from '../../../../src/assets/cdp.png';
import GRI from '../../../../src/assets/GRI.png';
import MODS from '../../../../src/assets/mods.png';
import QUES from '../../../../src/assets/ques.png';
import SASB from '../../../../src/assets/SASB.png';
import TCFD from '../../../../src/assets/TCFDIcon.png';

import {
  frameworkRoute,
  frameworkSubRoutes,
  subCategoryConstants
} from './frameworkRoutes';

export const FrameworkObj = [
  {
    key: '1',
    icon: GRI,
    shortTitle: 'GRI',
    title: 'Global Reporting Initiative',
    content: `The Global Reporting Initiative (GRI), sets standards for sustainability reporting, 
              enabling organizations worldwide to disclose their environmental, social, and 
              governance impacts transparently.`,
    buttonText: 'Continue',
    timeline: [
      {
        key: '1',
        ptitle: 'General',
        routes: frameworkSubRoutes.GRI.general,
        shortTitle: 'General'
      },
      {
        key: '2',
        ptitle: 'Environmental',
        routes: frameworkSubRoutes.GRI.environmental,
        shortTitle: 'Environmental'
      },
      {
        key: '3',
        ptitle: 'Social',
        routes: frameworkSubRoutes.GRI.social,
        shortTitle: 'Social'
      },
      {
        key: '4',
        ptitle: 'Governance',
        routes: frameworkSubRoutes.GRI.governance,
        shortTitle: 'Governance'
      }
    ],
    timeLineRender: [
      {icon: MODS, title: 'No. of Modules', value: 0},
      {icon: QUES, title: 'Question Answered', value: 0, total: 100}
    ],
    route: frameworkRoute.GRI
  },
  {
    key: '2',
    icon: BRSR,
    shortTitle: 'BRSR',
    title: 'Business Responsibility and Sustainability Report',
    content: `Business Reporting on Sustainable Development Goals in 
              India encourages companies to integrate SDGs into operations, 
              promoting responsible and sustainable business practices.`,
    buttonText: 'Continue',
    timeline: [
      {
        key: '1',
        ptitle: 'Section A : General Disclosure',
        routes: frameworkSubRoutes.BRSR.section_a,
        shortTitle: 'Section A : General Disclosure'
      },
      {
        key: '2',
        ptitle: 'Section B : Management And Process Disclosures',
        routes: frameworkSubRoutes.BRSR.section_b,
        shortTitle: 'Section B : Management And Process Disclosures'
      },
      {
        key: '3',
        ptitle: 'Section C : Principle Wise Performance Disclosure',
        routes: frameworkSubRoutes.BRSR.section_c,
        shortTitle: 'Section C : Principle Wise Performance Disclosure'
      }
    ],
    timeLineRender: [
      {icon: MODS, title: 'No. of Modules', value: 30},
      {icon: QUES, title: 'Question Answered', value: 30, total: 100}
    ],
    route: frameworkRoute.BRSR
  },
  {
    key: '3',
    icon: TCFD,
    shortTitle: 'TCFD',
    title: 'Task Force on Climate-related Financial Disclosures Report',
    content: `The Task Force on Climate-related Financial Disclosures (TCFD) 
              is a global initiative that provides a framework for organizations to disclose 
              information about climate-related risks and opportunities, aiming for consistent, 
              comparable, and transparent reporting.`,
    buttonText: 'Continue',
    timeline: [
      {
        key: '1',
        ptitle: 'Governance',
        routes: frameworkSubRoutes.TCFD.governance,
        shortTitle: 'Governance'
      },
      {
        key: '2',
        ptitle: 'Strategy',
        routes: frameworkSubRoutes.TCFD.strategy,
        shortTitle: 'Strategy'
      },
      {
        key: '3',
        ptitle: 'Risk Management',
        routes: frameworkSubRoutes.TCFD.risk_management,
        shortTitle: 'Risk Management'
      },
      {
        key: '4',
        ptitle: 'Metrics & Targets',
        routes: frameworkSubRoutes.TCFD.matrics_targets,
        shortTitle: 'Metrics & Targets'
      }
    ],
    timeLineRender: [
      {icon: MODS, title: 'No. of Modules', value: 1},
      {icon: QUES, title: 'Question Answered', value: 30, total: 100}
    ],
    route: frameworkRoute.TCFD
  },
  {
    key: '4',
    icon: SASB,
    shortTitle: 'SASB',
    title: 'Sustainability Accounting Standards Board',
    content: `Sustainability Accounting Standards Board, establishes
               industry-specific standards for companies to disclose financially
                material sustainability information in their reporting.`,
    buttonText: 'Continue',
    timeline: [
      {
        key: '1',
        ptitle: 'Real Estate',
        routes: frameworkSubRoutes.SASB.realEstate,
        category: 1,
        shortTitle: 'Real Estate'
      },
      {
        key: '2',
        ptitle: 'Software & IT Services',
        routes: frameworkSubRoutes.SASB.IT,
        category: 2,
        shortTitle: 'Software & IT Services'
      },
      {
        key: '3',
        ptitle: 'Auto Parts',
        routes: frameworkSubRoutes.SASB.automotive,
        category: 3,
        shortTitle: 'Auto Parts'
      }
    ],
    timeLineRender: [
      {icon: MODS, title: 'No. of Modules', value: 0},
      {icon: QUES, title: 'Question Answered', value: 0, total: 100}
    ],
    route: frameworkRoute.SASB
  },
  {
    key: '5',
    icon: CDP,
    shortTitle: 'CDP SME',
    title: 'Carbon Disclosure Project - SME',
    content: `The Carbon Disclosure Project enables companies to measure
     and disclose their environmental impacts, promoting transparency and 
     accountability in managing climate change, water, and other sustainability-related 
     risks and opportunities.`,
    buttonText: 'Continue',
    timeline: [
      {
        key: '1',
        ptitle: 'SME Introduction',
        routes: frameworkSubRoutes.CDP_SME.smeIntroduction,
        shortTitle: 'SME Introduction'
      },
      {
        key: '2',
        ptitle:
          'SME Identification, Assessment and Management of Risks and Opportunities',
        routes: frameworkSubRoutes.CDP_SME.smeManagement,
        shortTitle:
          'SME Identification, Assessment and Management of Risks and Opportunities'
      },
      {
        key: '3',
        ptitle: 'SME Disclosure of Risks and Opportunities',
        routes: frameworkSubRoutes.CDP_SME.smeDisclosure,
        shortTitle: 'SME Disclosure of Risks and Opportunities'
      },
      {
        key: '4',
        ptitle: 'SME Governance',
        routes: frameworkSubRoutes.CDP_SME.smeGovernance,
        shortTitle: 'SME Governance'
      },
      {
        key: '5',
        ptitle: 'SME Business Strategy',
        routes: frameworkSubRoutes.CDP_SME.businessStrategy,
        shortTitle: 'SME Business Strategy'
      },
      {
        key: '6',
        ptitle: 'SME Environmental Performance - Consolidation Approach',
        routes: frameworkSubRoutes.CDP_SME.performanceConsolidationApproach,
        shortTitle: 'SME Environmental Performance - Consolidation Approach'
      },
      {
        key: '7',
        ptitle: 'SME Environmental Performance - Climate Change',
        routes: frameworkSubRoutes.CDP_SME.performanceClimateChange,
        shortTitle: 'SME Environmental Performance - Climate Change'
      },
      {
        key: '8',
        ptitle: 'SME Sign Off',
        routes: frameworkSubRoutes.CDP_SME.smeSignOff,
        shortTitle: 'SME Sign Off'
      }
    ],
    timeLineRender: [
      {icon: MODS, title: 'No. of Modules', value: 1},
      {icon: QUES, title: 'Question Answered', value: 30, total: 100}
    ],
    route: frameworkRoute.CDP_SME
  },
  {
    key: '6',
    icon: CDP,
    shortTitle: 'CDP CORPORATE',
    title: 'Carbon Disclosure Project - Corporate',
    content: `The Carbon Disclosure Project enables companies to measure
     and disclose their environmental impacts, promoting transparency and 
     accountability in managing climate change, water, and other sustainability-related 
     risks and opportunities.`,
    buttonText: 'Continue',
    timeline: [
      {
        key: '1',
        ptitle: 'Corporate Introduction',
        routes: frameworkSubRoutes.CDP_CORPORATE.corporateIntroduction,
        shortTitle: 'Corporate Introduction'
      },
      {
        key: '2',
        ptitle:
          'Corporate Identification, assessment, and management of dependencies, impacts, risks, and opportunities',
        routes: frameworkSubRoutes.CDP_CORPORATE.corporateManagement,
        shortTitle:
          'Corporate Identification, assessment, and management of dependencies, impacts, risks, and opportunities'
      },
      {
        key: '3',
        ptitle: 'Corporate Disclosure of Risks and Opportunities',
        routes: frameworkSubRoutes.CDP_CORPORATE.corporateDisclosure,
        shortTitle: 'Corporate Disclosure of Risks and Opportunities'
      },
      {
        key: '4',
        ptitle: 'Corporate Governance',
        routes: frameworkSubRoutes.CDP_CORPORATE.corporateGovernance,
        shortTitle: 'Corporate Governance'
      },
      {
        key: '5',
        ptitle: 'Corporate Business Strategy',
        routes: frameworkSubRoutes.CDP_CORPORATE.corporateStrategy,
        shortTitle: 'Corporate Business Strategy'
      },
      {
        key: '6',
        ptitle: 'Corporate Environmental Performance - Consolidation Approach',
        routes:
          frameworkSubRoutes.CDP_CORPORATE
            .corporatePerformanceConsolidationApproach,
        shortTitle:
          'Corporate Environmental Performance - Consolidation Approach'
      },
      {
        key: '7',
        ptitle: 'Corporate Environmental Performance - Climate Change',
        routes:
          frameworkSubRoutes.CDP_CORPORATE.corporatePerformanceClimateChange,
        shortTitle: 'Corporate Environmental Performance - Climate Change'
      },
      {
        key: '8',
        ptitle: 'Environmental Performance - Forests',
        routes:
          frameworkSubRoutes.CDP_CORPORATE
            .corporateEnvironmentalPerformanceForests,
        shortTitle: 'Environmental Performance - Forests'
      },
      {
        key: '9',
        ptitle: 'Environmental Performance - Water Security',
        routes:
          frameworkSubRoutes.CDP_CORPORATE
            .corporateEnvironmentalPerformanceWaterSecurity,
        shortTitle: 'Environmental Performance - Water Security'
      },
      {
        key: '10',
        ptitle: 'Environmental Performance - Plastics',
        routes:
          frameworkSubRoutes.CDP_CORPORATE
            .corporateEnvironmentalPerformancePlastics,
        shortTitle: 'Environmental Performance - Plastics'
      },
      {
        key: '11',
        ptitle: 'Environmental Performance - Biodiversity',
        routes:
          frameworkSubRoutes.CDP_CORPORATE
            .corporateEnvironmentalPerformanceBiodiversity,
        shortTitle: 'Environmental Performance - Biodiversity'
      },
      {
        key: '12',
        ptitle: 'Environmental Performance - Financial Services',
        routes:
          frameworkSubRoutes.CDP_CORPORATE
            .corporateEnvironmentalPerformanceFinancialServices,
        shortTitle: 'Environmental Performance - Financial Services'
      },
      {
        key: '13',
        ptitle: 'Further Information And Sign Off',
        routes:
          frameworkSubRoutes.CDP_CORPORATE
            .corporateFurtherInformationAndSignOff,
        shortTitle: 'Further Information And Sign Off'
      }
    ],
    timeLineRender: [
      {icon: MODS, title: 'No. of Modules', value: 1},
      {icon: QUES, title: 'Question Answered', value: 30, total: 100}
    ],
    route: frameworkRoute.CDP_CORPORATE
  },
  {
    key: '7',
    icon: CBAM,
    shortTitle: 'CBAM',
    title: 'Cross Border Adjustment Mechanism - Exporter',
    content: `CBAM requires exporters to the EU to disclose and pay for the carbon emissions 
              embedded in their products to maintain compliance and market access.`,
    buttonText: 'Continue',
    timeline: [
      {
        key: '1',
        ptitle: 'SECTION 1 — Exporter & Installation Profile',
        routes: frameworkSubRoutes.CBAM.section1ExporterAndInstallationProfile,
        shortTitle: 'SECTION 1 — Exporter & Installation Profile',
        subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
      },
      {
        key: '2',
        ptitle: 'SECTION 2 — Activity Data & Production System Boundary',
        routes:
          frameworkSubRoutes.CBAM
            .section2ActivityDataAndProductionSystemBoundary,
        shortTitle: 'SECTION 2 — Activity Data & Production System Boundary',
        subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
      },
      {
        key: '3',
        ptitle: 'SECTION 3 — Direct Embedded Emissions (Scope 1)',
        routes:
          frameworkSubRoutes.CBAM.section3EmissionFactorsAndEmissionsScope1,
        shortTitle: 'SECTION 3 — Direct Embedded Emissions (Scope 1)',
        subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
      },
      {
        key: '4',
        ptitle: 'SECTION 4 — Indirect Embedded Emissions (Electricity)',
        routes:
          frameworkSubRoutes.CBAM.section4IndirectEmbeddedEmissionsElectricity,
        shortTitle: 'SECTION 4 — Indirect Embedded Emissions (Electricity)',
        subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
      },
      {
        key: '5',
        ptitle: 'SECTION 5 — Precursor Emissions',
        routes: frameworkSubRoutes.CBAM.section5PrecursorEmissions,
        shortTitle: 'SECTION 5 — Precursor Emissions',
        subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
      },
      {
        key: '6',
        ptitle: 'SECTION 6 — Methodology, Data Quality, Verification',
        routes:
          frameworkSubRoutes.CBAM.section6MethodologyDataQualityVerification,
        shortTitle: 'SECTION 6 — Methodology, Data Quality, Verification',
        subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
      },
      {
        key: '7',
        ptitle: 'SECTION 7 — Emission Summary & Export-Specific Output',
        routes:
          frameworkSubRoutes.CBAM
            .section7EmissionSummaryAndExportSpecificOutput,
        shortTitle: 'SECTION 7 — Emission Summary & Export-Specific Output',
        subCategory: subCategoryConstants.CEMENT_SUB_CATEGORY
      },
      {
        key: '8',
        ptitle: 'SECTION 1 – PLANT & PRODUCTION INFORMATION',
        routes:
          frameworkSubRoutes.CBAM_IRON_AND_STEEL
            .section1PlantAndProductionInformation,
        shortTitle: 'SECTION 1 – PLANT & PRODUCTION INFORMATION',
        subCategory: subCategoryConstants.IRON_AND_STEEL_SUB_CATEGORY
      },
      {
        key: '9',
        ptitle: 'SECTION 2 – SOURCE STREAM & DIRECT EMISSIONS DATA',
        routes:
          frameworkSubRoutes.CBAM_IRON_AND_STEEL
            .section2SourceStreamAndDirectEmissionsData,
        shortTitle: 'SECTION 2 – SOURCE STREAM & DIRECT EMISSIONS DATA',
        subCategory: subCategoryConstants.IRON_AND_STEEL_SUB_CATEGORY
      },
      {
        key: '10',
        ptitle: 'SECTION 3 – ELECTRICITY & INDIRECT EMISSIONS',
        routes:
          frameworkSubRoutes.CBAM_IRON_AND_STEEL
            .section3ElectricityAndIndirectEmissions,
        shortTitle: 'SECTION 3 – ELECTRICITY & INDIRECT EMISSIONS',
        subCategory: subCategoryConstants.IRON_AND_STEEL_SUB_CATEGORY
      },
      {
        key: '11',
        ptitle: 'SECTION 4 – PROCESS-LEVEL PRODUCTION & EMISSIONS DATA',
        routes:
          frameworkSubRoutes.CBAM_IRON_AND_STEEL
            .section4ProcessLevelProductionAndEmissionsData,
        shortTitle: 'SECTION 4 – PROCESS-LEVEL PRODUCTION & EMISSIONS DATA',
        subCategory: subCategoryConstants.IRON_AND_STEEL_SUB_CATEGORY
      },
      {
        key: '12',
        ptitle: 'SECTION 5 – PRECURSOR (PURCHASED INPUT) EMISSIONS DATA',
        routes:
          frameworkSubRoutes.CBAM_IRON_AND_STEEL
            .section5PrecursorPurchasedInputEmissionsData,
        shortTitle: 'SECTION 5 – PRECURSOR (PURCHASED INPUT) EMISSIONS DATA',
        subCategory: subCategoryConstants.IRON_AND_STEEL_SUB_CATEGORY
      },
      {
        key: '13',
        ptitle: 'SECTION 6 – CARBON PRICING & TAX ADJUSTMENT',
        routes:
          frameworkSubRoutes.CBAM_IRON_AND_STEEL
            .section6CarbonPricingAndTaxAdjustment,
        shortTitle: 'SECTION 6 – CARBON PRICING & TAX ADJUSTMENT',
        subCategory: subCategoryConstants.IRON_AND_STEEL_SUB_CATEGORY
      },
      {
        key: '14',
        ptitle: 'SECTION 7 – SHIPMENT & CUSTOMS INFORMATION',
        routes:
          frameworkSubRoutes.CBAM_IRON_AND_STEEL
            .section7ShipmentAndCustomsInformation,
        shortTitle: 'SECTION 7 – SHIPMENT & CUSTOMS INFORMATION',
        subCategory: subCategoryConstants.IRON_AND_STEEL_SUB_CATEGORY
      }
    ],
    timeLineRender: [
      {icon: MODS, title: 'No. of Modules', value: 1},
      {icon: QUES, title: 'Question Answered', value: 30, total: 100}
    ],
    route: frameworkRoute.CBAM
  },
  {
    isComingSoon: true,
    shortTitle: 'SBTi',
    title: 'Science Based Targets Initiative'
  }
];

export const FY = {
  current: 'Current Financial Year',
  previous: 'Previous Financial Year',
  previousToPrevious: 'PreviousToPrev Financial Year'
};

enum ReportExtensions {
  PDF = 'pdf',
  DOCX = 'docx',
  DOC = 'doc',
  XBRL = 'xbrl'
}

export const ReportExtensionsLabels = [
  {key: ReportExtensions.PDF, label: 'PDF'},
  {key: ReportExtensions.DOCX, label: 'DOCX'},
  {key: ReportExtensions.DOC, label: 'DOC'},
  {key: ReportExtensions.XBRL, label: 'XBRL'}
];

export const ReportExtensionPDFOnly = [
  {key: ReportExtensions.PDF, label: 'PDF'}
];
